<template>
    <div id="painel">
        <h2 class="font-exo italic font-bold text-lg w-4/5 py-10 md:text-2xl xl:text-3xl">Painel COVID-19</h2>
        <div id="contadores" class="flex flex-wrap">
            <quantidade-demissoes class="w-full md:w-1/2 lg:w-1/4 mb-4" :count="quantidadeDemissoes"/>
        </div>
        <div id="graphs" class="flex flex-wrap -mx-2">
            <div class="px-2 w-full md:w-1/2 mb-4 lg:w-1/2 mb-4">
                <participacoes-por-segmento :statistics="participacoesPorSegmento"/>
            </div>
            <div class="px-2 w-full md:w-1/2 mb-4 lg:w-1/2">
                <quantidade-demissoes-por-segmento :statistics="quantidadeDemissoesPorSegmento"/>
            </div>
            <div class="px-2 w-full md:w-1/2 mb-4 lg:w-1/2">
                <funcionamento-empresas :statistics="funcionamentoEmpresas"/>
            </div>
            <div class="px-2 w-full md:w-1/2 mb-4 lg:w-1/2">
                <reposicao-estoque :statistics="reposicaoEstoque"/>
            </div>
        </div>
    </div>
</template>

<script>
    import ParticipacoesPorSegmento from "@/components/graphs/ParticipacoesPorSegmento";
    import QuantidadeDemissoesPorSegmento from "@/components/graphs/QuantidadeDemissoesPorSegmento";
    import QuantidadeDemissoes from "@/components/graphs/QuantidadeDemissoes";
    import FuncionamentoEmpresas from "../components/graphs/FuncionamentoEmpresas";
    import ReposicaoEstoque from "../components/graphs/ReposicaoEstoque";
    import repository from "../repository";

    export default {
        components: {
            FuncionamentoEmpresas,
            ParticipacoesPorSegmento,
            QuantidadeDemissoes,
            QuantidadeDemissoesPorSegmento,
            ReposicaoEstoque
        },
        mounted: function () {
            repository.obterParticipacoesPorSegmento().then(response => this.participacoesPorSegmento = response)
            repository.obterQuantidadeDemissoes().then(response => this.quantidadeDemissoes = response.value)
            repository.obterQuantidadeDemissoesPorSegmentos().then(segmentos => this.quantidadeDemissoesPorSegmento = segmentos)
            repository.obterFuncionamentoEmpresas().then(dados => this.funcionamentoEmpresas = dados)
            repository.obterReposicaoEstoque().then(dados => this.reposicaoEstoque = dados)
        },
        data() {
            return {
                quantidadeDemissoesPorSegmento: [],
                participacoesPorSegmento: [],
                quantidadeDemissoes: 0,
                funcionamentoEmpresas: [],
                reposicaoEstoque: []
            }
        }
    }
</script>